{{ set enableSubtitle = subtitle && subtitle.type === 'webvtt' }}
<video
    class="mfunsPlayer-video {{ if current }}mfunsPlayer-video-current{{ /if }}"
    webkit-playsinline
    {{ if airplay }} x-webkit-airplay="allow" {{ /if }}
    playsinline
    {{ if pic }}poster="{{ pic }}"{{ /if }}
    {{ if screenshot || enableSubtitle }}crossorigin="anonymous"{{ /if }}
    {{ if url }}src="{{ url }}"{{ /if }}
    >
</video>